interface IElements {
  [key: string]: Element[];
}

export class Elements {
  private _elements: IElements = {};

  constructor() {
    const elementsWithAttribute = document.querySelectorAll('[cc-element]');

    elementsWithAttribute.forEach((element: Element) => {
      const attributeName = element.getAttribute('cc-element');
      if (attributeName) {
        // Convert the attribute value to camelCase to match the property names in IElements
        const propertyName = this.toCamelCase(attributeName);
        if (!this._elements[propertyName]) {
          this._elements[propertyName] = [];
        }
        this._elements[propertyName].push(element);
      }
    });
  }

  public get(name: string): Element | null {
    return this._elements[name] ? this._elements[name][0] : null;
  }

  public getAll(name: string): Element[] {
    return this._elements[name] || [];
  }

  // Convert a string to camelCase
  private toCamelCase(str: string): string {
    return str
      .split('-')
      .map((word, index) => {
        if (index === 0) return word.toLowerCase();
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join('');
  }

  // Provide a getter to access the elements safely
  get elements(): IElements {
    return this._elements;
  }
}
